export default __webpack_public_path__ + "static/media/remodeling.71377cda.png";